import { render, staticRenderFns } from "./AssetsOverTime.vue?vue&type=template&id=99608afc&"
import script from "./AssetsOverTime.vue?vue&type=script&lang=js&"
export * from "./AssetsOverTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports